import { useEffect, useState, useRef } from "react";
import {
  Link as LinkRoute,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../component/Pagination";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import BannerSkeleton from "../../component/skeleton/BannerSkeleton";
import EnableSwitch from "../../component/admin/goalCategories/EnableSwitch";
import { fetchFeaturedLinks } from "../../action/getFeaturedLinksAdmin";

const goalsColumn = [
  { id: "category_select", label: "category_select", width: "5%" },
  { id: "name", label: "NAME", width: "75%" },
  { id: "enable", label: "ENABLE", width: "5%" },
  // { id: "category_actions", label: "ACTIONS", width: "15%" },
];

export default function FeaturedLinks() {
  const navigate = useNavigate();
  const goalCategoriesData = useSelector((state) => state.goalCategoriesAdmin);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const limit = searchParams.get("limit");
  const search = searchParams.get("search");
  const remove = searchParams.get("delete");
  const [isLoading, setIsLoading] = useState(false);
  const [records, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLimit, setCurrentLimit] = useState(2);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [recordFrom, setRecordFrom] = useState(0);
  const [recordTo, setRecordTo] = useState(0);

  useEffect(() => {
    dispatch(fetchFeaturedLinks(token, 1));
  }, [dispatch, token]);

  const handleChangePage = (event, newPage) => {
    // dispatch(fetchFeaturedLinks(token, newPage));
  };

  useEffect(() => {
    if (goalCategoriesData?.data?.records?.length) {
      const { records, pagination } = goalCategoriesData?.data;
      // const { records, pagination } = goalCategoriesData?.data?.filter(
      //   (obj) => obj.name != "My Football League",
      // );
      // setData(records?.filter((obj) => obj.name != "My Football League") || []);
      setData(records);
      setCurrentPage(pagination?.page || 1);
      setCurrentLimit(pagination?.limit || 10);
      setTotalPages(pagination?.totalPages || 1);
      setTotalRecords(pagination?.totalRecords || 0);
      setRecordFrom(pagination?.recordFrom || 0);
      setRecordTo(pagination?.recordTo || 0);
    } else {
      setData("NO Data");
    }
  }, [goalCategoriesData]);

  const createPaginationUrl = (newPage, search, limit) => {
    const params = new URLSearchParams();
    if (newPage) {
      params.set("page", newPage.toString());
    }
    if (search) {
      params.set("search", search);
    }
    if (limit) {
      params.set("limit", limit.toString());
    }
    return params.toString() ? `?${params.toString()}` : "";
  };

  return (
    <>
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading ?? false}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box className="page_inner">
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "700px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id !== "category_select" ? (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        {column.label}
                      </TableCell>
                    ) : null,
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(records) && records.length > 0 ? (
                  records.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="property_name">
                          <Box className="td-wrapper">
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text"
                            >
                              {value?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            <EnableSwitch value={value} api={`featured-link`} />
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : records !== "NO Data" ? (
                  Array.from({ length: 10 }).map((_e, i) => (
                    <BannerSkeleton key={i} />
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {records}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>
    </>
  );
}
